export default {
      id: "arrow-slider-right-usage",
      viewBox: "0 0 42 42",
      url: __webpack_public_path__ + "global.svg#arrow-slider-right-usage",
      toString: function () {
        return this.url;
      }
    }


//////////////////
// WEBPACK FOOTER
// ./assets/images/icons/global/arrow-slider-right.svg
// module id = 6
// module chunks = 0